module.exports = __webpack_public_path__ + "static/media/covid_qr_p3_3.296cfdb5.png";